// extracted by mini-css-extract-plugin
module.exports = {"Title":"SearchedInfo_Title__1FIyj","Text":"SearchedInfo_Text__Nzv0A"};